import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Dialog, DialogContent, DialogTitle, DialogActions, Button, ButtonGroup } from '@material-ui/core';

import { FreeTextAutoComplete } from '..';

function DeliveryTimeDialog(props) {
  const [deliveryTimeValue, setDeliveryTimeValue] = useState(0);
  const { open, order, setDeliveryTime, onClose } = props;

  const times = [10, 15, 20, 30, 45, 60, 75, 90];
  const quickSelectTimes = [10, 20, 30, 60];
  const timeOptions = times.map(t => ({ title: String(t), value: t }));

  return (
    <Dialog
      open={open}
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle style={{ textAlign: 'center' }} id="alert-dialog-title">Lieferzeit setzen</DialogTitle>
      <DialogContent>
        <ButtonGroup color="primary" fullWidth aria-label="outlined primary button group" className="mb">
          {
            quickSelectTimes.map(time => (
              <Button
                variant={deliveryTimeValue == time ? 'contained' : 'outlined'}
                color="primary"
                key={'quickSelect'}
                onClick={() => setDeliveryTimeValue(time.toString())}
              >
                {time}{'\n'}Minuten
              </Button>
            ))
          }
        </ButtonGroup>
        <div style={{ marginTop: '20px' }}>
          <FreeTextAutoComplete
            className="mt"
            label="Lieferzeit (in Minuten)"
            value={deliveryTimeValue}
            onChange={newValue => setDeliveryTimeValue(newValue)}
            items={timeOptions}
            textFieldType="number"
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
        >
          Abbrechen
        </Button>
        <Button
          onClick={() => {
            const time = deliveryTimeValue.value || deliveryTimeValue.title;
            const deliveryTime = moment().add(time, 'minutes');
            setDeliveryTime(order.id, deliveryTime.toISOString());
            onClose();
          }}
          color="primary"
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DeliveryTimeDialog.propTypes = {
  open: PropTypes.bool,
  order: PropTypes.object,
  onClose: PropTypes.func,
  setDeliveryTime: PropTypes.func,
};

DeliveryTimeDialog.defaultProps = {
  open: false,
  order: {},
  onClose: () => {},
  setDeliveryTime: () => {},
};

export default DeliveryTimeDialog;
